import React from "react";
import { withStyles} from "@material-ui/core";
import {Select,FormControl,InputLabel,Typography} from '@material-ui/core';
import PropTypes from "prop-types";
import cx from "classnames";
import {compose} from 'redux';

import Clear from "@material-ui/icons/Clear"
import Check from "@material-ui/icons/Check"


import customInputStyle from "../../assets/jss/material-dashboard-react/customInputStyle";
import { CountryDropdown } from "react-country-region-selector";

class CountryDropDownSelect extends React.Component{
    constructor(props) {
        super(props);
    }

    state ={
        selectedOption: "",
        country: ""

    }

    // handleChange = event => {
    //     this.setState({ selectedOption: event.target.value });
    //     if(this.props.onChange){
    //         console.log(this.props.onChange+ "Does this work")
    //         this.props.onChange(event.target.value)
    //     }

    // };

    selectCountry (country) {
      console.log(country+ " This value is setState of country");
      this.setState({ country: country });
       if(country){
         console.log(country+ " Does this work")
         this.props.onChange(country)
     }
      
      
    }
  
    selectRegion (val) {
      this.setState({ region: val });
    }


    render({...props}){
        //const val = this.props.val
        
        const {country} = this.state;
        //console.log(country+"This was choosen right now")
        const {
            labelText,
            options,
            inputProps,
            formControlProps,
            classes,
            id,
            error,
            success} = this.props
        //const {error} = props;
        //console.log("This the error",this.props.error);
        const marginTop = cx({
            [classes.marginTop]: labelText === undefined
        });

        const labelClasses = cx({
            [" " + classes.labelRootError]: error,
            [" " + classes.labelRootSuccess]: success && !error
        });



        return(
            <FormControl style={styles.formcontrol} {...formControlProps} className={formControlProps.className + " " + classes.formControl}>
                       {labelText !== undefined ? (
        <Typography style={styles.label}>
      {labelText}
   </Typography>
      ) : null}  
      {/* <InputLabel className={classes.labelRoot + labelClasses} htmlFor={id}>{labelText}</InputLabel> */}
      <CountryDropdown classes={classes.dropdown}
      value={country}
      onChange={(country) => this.selectCountry(country)}
      {...inputProps}
      // onBlur={() => {
                      //   this.setState({
                      //   countryError: validate('country', this.state.country)
                      //     })
                      // }}
      />
                {/* <Select
                    native
                    value={this.state.selectedOption.value}
                    onChange={this.handleChange}
                    inputProps={{
                        id: {id},
                    }}
                    classes={{
                        root: marginTop,
                        disabled: classes.disabled,
                    }}
                >


                    <option value=""/>

                    {options?
                        options.map((option,index)=> {
                            return <option value={option.value} key={index}>{option.text}</option>
                        }):null
                    }
                </Select> */}
                {this.props.error ? <Typography style={styles.errorColor}>{this.props.error}</Typography> : null}
                {/* {error ? (
                    <Clear className={classes.feedback + " " + classes.labelRootError} />
                ) : success ? (
                    <Check className={classes.feedback + " " + classes.labelRootSuccess} />
                ) : null} */}
            </FormControl>
        )



    }






}

CountryDropDownSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    value: PropTypes.string,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.string,
    success: PropTypes.bool
  };

const styles={
    label: {
        display: "flex",
        //...defaultFont,
        color: "#AAAAAA",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        //marginTop: "16px"
      },
      dropdown:{
        //border: 0,
        cursor: "pointer",
        font: "inherit",
        borderRightWidth: 0,
        borderLeftWidth:0,
        borderTopWidth:0,
        padding: "6px 0 7px",
        // justifyContent:"center",
        // margin: "0 0 0 50px",
        position: "relative",
        //padding: "0 15px",
      },
      formcontrol:{
        margin: "27px 0 0 0",
        position: "relative",
        paddingBottom: "10px",
      },
      errorColor: {
        marginRight: "auto",
        color:"#f44336",
      },



}



export default 
compose(
withStyles(styles))
(CountryDropDownSelect)
;


// WEBPACK FOOTER //
// ./src/components/CountryDropDown/CountryDropDownSelect.jsx